import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-logisticdashboard',
  templateUrl: './logisticdashboard.component.html',
  styleUrls: ['./logisticdashboard.component.scss']
})
export class LogisticdashboardComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
